export const generateRandomString = (): string => Math.random().toString(36).substr(2);

export const LONG_DASH = `\u2014`;

export const isString = (x: unknown): x is string => typeof x === 'string';
